<template>
  <div style="width:100%;float:left;">
    <CWidgetDropdown color="gradient-primary" :header="'' + data.length" text="New Orders">
      <template #footer>
        <CCardFooter class="card-footer px-3 py-2 mt-2">
          <CLink
            class="font-weight-bold font-xs btn-block"
            @click="viewOrders()"
          >
            View Orders
            <CIcon name="cil-arrowRight" class="float-right" width="16"/>
          </CLink>
        </CCardFooter>
      </template>
    </CWidgetDropdown>
    <CModal
      title="New Orders"
      :show.sync="viewModal"
      size="lg"
    >
      <div style="width:100%;float:left;">
        <h4 style="width:100%;float:left;text-align:center;">Click to go to order.</h4>
        <table class="table" v-if="data">
          <thead>
            <tr>
              <td>Log#</td>
              <td>Cust</td>
              <td>PO</td>
              <td>Status</td>
              <td>Date</td>
            </tr>
          </thead>
          <tbody>
            <tr v-for="val in data" @click="goToOrder(val)">
              <td>{{val.as400_log_number}}</td>
              <td>{{val.customer_number}}</td>
              <td>{{val.po_number}}</td>
              <td>{{val.status}}</td>
              <td>{{val.local_created_at}}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </CModal>
  </div>
</template>
<script>
var methods = {}

methods.getNewOrders = function () {
  const postData = {
    csr: this.csr
  }
  axios.post(this.$apiAdress + '/api/orders/getNewOrdersByCsr?token=' + localStorage.getItem('api_token'), postData).then(res => {
    console.log(res)
    this.data = res.data
    this.$emit('set', 'new_orders_widget')
  }).catch(e => {
    console.log(e)
  })
}

methods.goToOrder = function (val) {
  this.$router.push('/order/' + val.order_id)
}

methods.viewOrders = function () {
  this.viewModal = true
}

export default {
    // ===Component name
    name: "NewOrdersWidget",
    // ===Props passed to component
    props: ['csr'],
    // ===Components used by this component
    components: {

    },
    // ====component Data properties
    data(){
        return{
          data: [],
          viewModal: false
        }
    },
    // ===Code to be executed when Component is mounted
    mounted() {
      this.getNewOrders()
    },
    // ===Computed properties for the component
    computed: {},
    // ===Component methods
    methods: methods
}
</script>
<!-- styles -->
<!-- adding scoped attribute will apply the css to this component only -->
<style scoped></style>
